export const HEADER_CLASS = "header-wrapper";
